import { RuleTabEnum } from '../enum/RuleTab.enum';
import { ModalContent, RuleTenant } from '../RuleService.const';

export function getModalContent(type: RuleTabEnum) {
    return ModalContent[type];
}

export function getTenants() {
    return Object.keys(RuleTenant).map((key) => {
        return {
            label: (RuleTenant as any)[parseInt(key) as number],
            value: parseInt(key),
        };
    }) as any;
}

export function mapToDefault(type: any) {
    ModalContent[type]?.fields?.forEach((k) => {
        if (k.hasChildItem) {
            k.child = [];
        }
        k['value'] = '';
    });
    return ModalContent[type];
}
export function mapToPayload(type: RuleTabEnum, modalState: any) {
    if (type == RuleTabEnum.CriteriaType) {
        return Object.fromEntries(
            modalState.fields.map((val: any) => {
                if (val.hasChildItem) {
                    return [val.key, val.child];
                }
                return [val.key, val.value];
            })
        );
    }
    if (type == RuleTabEnum.RuleTemplate) {
        return Object.fromEntries(
            modalState.fields.map((val: any) => {
                if (val.hasChildItem) {
                    return [val.key, val.child];
                }
                return [val.key, val.value];
            })
        );
    }
}
